<div class="vehicle-list-container" [class.edit-mode]="isEditMode">
  <!-- Edit Vehicle Title -->
  <div *ngIf="isEditMode" class="edit-header">
    <h3 class="edit-title">Edit Vehicle</h3>
  </div>
  
  <!-- Vehicle Lookup Section using Add Vehicle Form Component -->
  <div class="lookup-section">
    <app-add-vehicle-form
      [vehicleForm]="{ state: selectedState, licensePlate: licensePlate }"
      [vehicleData]="vehicleData"
      [vehicleErrorMessage]="errorMessage"
      [isLoadingVehicle]="isLoading"
      [isBookingChecked]="isBookingChecked"
      [isBookingDisabled]="isBookingDisabled"
      [isRadioButton]="isRadioButton"
      [showHeader]="false"
      [showSaveCancelButtons]="showSaveCancelButtons"
      [showBookingCheckbox]="showBookingCheckbox"
      [customerId]="customerId"
      [isEditMode]="isEditMode"
      (vehicleFormChange)="onVehicleFormChange($event)"
      (vehicleDataChange)="onVehicleDataChange($event)"
      (vehicleErrorMessageChange)="onVehicleErrorMessageChange($event)"
      (isLoadingVehicleChange)="onIsLoadingVehicleChange($event)"
      (bookingChange)="onBookingChange($event)"
      (vehicleCreatedManually)="onVehicleCreatedManually($event)"
      (manualFieldsVisibilityChange)="onManualFieldsVisibilityChange($event)">
    </app-add-vehicle-form>
  </div>

  <!-- Shimmer Loader - Shown during API call -->
  <div *ngIf="isLoading" class="shimmer-container">
    <div class="shimmer-field">
      <div class="shimmer-label"></div>
      <div class="shimmer-input"></div>
    </div>
    
    <ng-container *ngTemplateOutlet="shimmerRow"></ng-container>
    <ng-container *ngTemplateOutlet="shimmerRow"></ng-container>
  </div>


  <!-- Action Buttons - Only show when showSaveCancelButtons is true -->
  <div *ngIf="showSaveCancelButtons" class="edit-actions">
    <button 
      type="button" 
      class="btn btn-tertiary" 
      (click)="onCancelEdit()">
      Cancel
    </button>
    <button 
      type="button" 
      class="btn btn-outline" 
      [class.disabled]="!canSave"
      [disabled]="!canSave"
      (click)="onSaveEdit()">
      Save
    </button>
  </div>
</div>

<!-- Shimmer Row Template (reused for loading skeleton rows) -->
<ng-template #shimmerRow>
  <div class="shimmer-row">
    <div class="shimmer-field">
      <div class="shimmer-label"></div>
      <div class="shimmer-input"></div>
    </div>
    <div class="shimmer-field">
      <div class="shimmer-label"></div>
      <div class="shimmer-input"></div>
    </div>
  </div>
</ng-template>
